import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { monoFontSx } from "../ThemeContext";

const formatMonth = (ym) => {
  const [year, month] = String(ym).split("-").map(Number);
  if (!year || !month) return ym;
  return new Date(year, month - 1, 1).toLocaleDateString(undefined, { month: "short", year: "2-digit" });
};

function ChartTooltip({ active, payload }) {
  const theme = useTheme();
  if (!active || !payload?.length) return null;
  const point = payload[0].payload;
  return (
    <Box
      sx={{
        px: 1.5,
        py: 1,
        borderRadius: 1.5,
        border: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
        boxShadow: theme.shadows[6],
      }}
    >
      <Typography sx={{ fontWeight: 800, ...monoFontSx }}>${Number(point.total).toFixed(2)}</Typography>
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {formatMonth(point.month)}
      </Typography>
    </Box>
  );
}

// Monthly totals -> discrete period columns (bars), not an interpolated
// line, since nothing continuous happened between the calendar-month buckets.
function SpendOverTimeChart({ data }) {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%", height: 240 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, bottom: 4, left: 4 }} accessibilityLayer>
          <CartesianGrid vertical={false} stroke={theme.palette.divider} />
          <XAxis
            dataKey="month"
            tickFormatter={formatMonth}
            tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
            axisLine={{ stroke: theme.palette.divider }}
            tickLine={false}
          />
          <YAxis
            tickFormatter={(v) => `$${v}`}
            tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
            axisLine={{ stroke: theme.palette.divider }}
            tickLine={false}
            width={56}
          />
          <Tooltip content={<ChartTooltip />} cursor={{ fill: theme.palette.action.hover }} />
          <Bar dataKey="total" fill={theme.palette.primary.main} radius={[4, 4, 0, 0]} maxBarSize={24} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default SpendOverTimeChart;
